/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timing_Sync_Hide_Event_LabelInputs */

const en_timing_sync_hide_event_label = /** @type {(inputs: Timing_Sync_Hide_Event_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hide Event`)
};

const fr_timing_sync_hide_event_label = /** @type {(inputs: Timing_Sync_Hide_Event_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masquer l'evenement`)
};

const de_timing_sync_hide_event_label = /** @type {(inputs: Timing_Sync_Hide_Event_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignis ausblenden`)
};

const it_timing_sync_hide_event_label = /** @type {(inputs: Timing_Sync_Hide_Event_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nascondi evento`)
};

const ru_timing_sync_hide_event_label = /** @type {(inputs: Timing_Sync_Hide_Event_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скрыть событие`)
};

const es_timing_sync_hide_event_label = /** @type {(inputs: Timing_Sync_Hide_Event_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocultar evento`)
};

const zh_cn2_timing_sync_hide_event_label = /** @type {(inputs: Timing_Sync_Hide_Event_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`隐藏事件`)
};

const ja_timing_sync_hide_event_label = /** @type {(inputs: Timing_Sync_Hide_Event_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントを非表示`)
};

const hi_timing_sync_hide_event_label = /** @type {(inputs: Timing_Sync_Hide_Event_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट छिपाएँ`)
};

const pt_pt2_timing_sync_hide_event_label = /** @type {(inputs: Timing_Sync_Hide_Event_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocultar evento`)
};

/**
* | output |
* | --- |
* | "Hide Event" |
*
* @param {Timing_Sync_Hide_Event_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timing_sync_hide_event_label = /** @type {((inputs?: Timing_Sync_Hide_Event_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timing_Sync_Hide_Event_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_timing_sync_hide_event_label(inputs)
	if (locale === "de") return de_timing_sync_hide_event_label(inputs)
	if (locale === "it") return it_timing_sync_hide_event_label(inputs)
	if (locale === "ru") return ru_timing_sync_hide_event_label(inputs)
	if (locale === "es") return es_timing_sync_hide_event_label(inputs)
	if (locale === "zh-CN") return zh_cn2_timing_sync_hide_event_label(inputs)
	if (locale === "ja") return ja_timing_sync_hide_event_label(inputs)
	if (locale === "hi") return hi_timing_sync_hide_event_label(inputs)
	if (locale === "pt-PT") return pt_pt2_timing_sync_hide_event_label(inputs)
	return en_timing_sync_hide_event_label(inputs)
});